import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bedroom golf",
  "description": "",
  "published": "2007-04-18T00:00:00.000Z",
  "redirect_from": ["/blog/bedroom-golf/swizec/229"],
  "categories": "funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Found this on a message board and it's just funny enough to be cool and sharable.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Each player shall furnish his own equipment for play, normally one club and two balls.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Play on course must be approved by the owner of the hole.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Unlike outdoor golf, the object is to get the club in the hole and keep the balls out.`}</p>
      </li>
    </ol>
    <p>{`4.For most effective play, the club should have a firm shaft. Course owners are permitted to check shaft stiffness before play begins.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Course owners reserve the right to restrict club length to avoid damage to the hole.`}</li>
    </ol>
    <p>{`6.Object of the game is to take as many strokes as necessary until the owner is satisfied play is complete. Failure to do so may result in being denied permission to play again.`}</p>
    <p>{`7.It is considered bad form to begin playing the hole immediately upon arrival. Experienced players will normally take time to admire the entire course, paying special attention to well formed mounds and bunkers.`}</p>
    <p>{`8.Players are cautioned not to mention other courses they have played or are currently playing to the owner of the course being played. Upset owners have been known to damage a players equipment for this reason.`}</p>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">
        <p parentName="li">{`Players are encouraged to have proper rain gear, just in case.`}</p>
        <p parentName="li">{`10.Players should not assume that the course is in shape to play at all times. Players may be embarrassed if they find the course temporarily under repair. Players are advised to be extremely tactful in this situation. More advanced players will find alternate means of play when this is the case.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Players should assume their match has been properly scheduled particularly when playing a new course for the 1st time. Previous players have been known to become irate if they discover someone else is playing what they considered a private course.`}</p>
      </li>
    </ol>
    <p>{`12.The owner of the course is responsible for the pruning of any bushes, which may reduce the visibility of the hole.`}</p>
    <p>{`13.Players are strongly advised to get the owners permission before attempting to play the backside.`}</p>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">
        <p parentName="li">{`Slow play is encouraged, however, players should be prepared to proceed at a quicker pace at the owners request.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`It is considered an outstanding performance, time permitting, to play the same hole several times in one match.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      